import { TagColor, TertiaryTagDropdownOption } from '@equip.health/ui';
import { CarePlanInterventionStatus } from '~/lib/types/carePlan/CarePlanInterventionStatus';

export const InterventionStatusDropdownOptions: TertiaryTagDropdownOption[] = [
  {
    value: CarePlanInterventionStatus.PLANNED,
    label: 'Planned',
    color: TagColor.purple,
  },
  {
    value: CarePlanInterventionStatus.IN_PROGRESS,
    label: 'In progress',
    color: TagColor.green,
  },
  {
    value: CarePlanInterventionStatus.COMPLETE,
    label: 'Complete',
    color: TagColor.periwinkle,
  },
  {
    value: CarePlanInterventionStatus.NOT_IMPLEMENTED,
    label: 'Not implemented',
    color: TagColor.red,
  },
];

export const RESOLVED_FREQUENCY_CODES = [
  'RESOLVED_DAYS',
  'RESOLVED_TIMES',
  'ZERO_DAYS',
  'ZERO_TIMES',
];

export const NOT_YET_ASSESSED_FREQUENCY_CODES = [
  'NOT_YET_ASSESSED_DAYS',
  'NOT_YET_ASSESSED_TIMES',
];

export const NOT_ASSESSED_FREQUENCY_CODES = [
  'NOT_ASSESSED_DAYS',
  'NOT_ASSESSED_TIMES',
];

export const GOAL_DESCRIPTION_MAX_HEIGHT = '250px';

export const CARE_PLAN_INTERVENTION_SECTION_LABELS = {
  ALL_OTHER_INTERVENTIONS: 'All other interventions',
  RELATED_INTERVENTIONS: 'Related interventions',
} as const;

export const CARE_PLAN_SECTION_IDS = {
  TREATMENT_GOALS: 'treatment-goals-section',
  CO_OCCURRING: 'co-occurring-section',
} as const;
